import { getBrowserSessionData, setBrowserSessionData } from '@/utils/browser-storage';

export function removeLastRoute({commit}, routes) {
    setBrowserSessionData('last-routes', routes);
    commit('setLastRoutes', routes);
}

export function removeLastSearch({commit}, searches) {
    setBrowserSessionData('last-searches', searches);
    commit('setLastSearches', searches);
}

export function loadLastSearches({commit}) {
    let lastSearches = getBrowserSessionData('last-searches');
    if(!lastSearches) {
        lastSearches = [];
    }
    commit('setLastSearches', lastSearches);
}

export function loadLastRoutes({commit}) {
    let lastRoutes = getBrowserSessionData('last-routes');
    if(!lastRoutes) {
        lastRoutes = [];
    }
    commit('setLastRoutes', lastRoutes);
}

export function storeSearchLocationLocally({commit, getters}, location) {
    const maxResults = 3;
    let lastSearches = getters.lastSearches;

    // check if location already exists in the list, if yes - remove it
    const locationIndex = lastSearches.findIndex(search => search.id === location.id);
    if(locationIndex >= 0) {
        lastSearches.splice(locationIndex, 1);
    }

    if(location.loadedIndex) delete location.loadedIndex

    lastSearches.unshift(location);
    if(lastSearches.length > maxResults) {
        lastSearches.length = maxResults;
    }
    setBrowserSessionData('last-searches', lastSearches);
    commit('setLastSearches', lastSearches);
}

export function storeRouteLocally({commit, getters}, route) {
    const maxResults = 3;
    let lastRoutes = getters.lastRoutes;

    // check if route already exists in the list, if yes - remove it
    const routeString = JSON.stringify(route);
    let routeIndex = -1;
    lastRoutes.forEach((lastRoute, lastRouteIndex) => {
        if(JSON.stringify(lastRoute) === routeString) {
            routeIndex = lastRouteIndex;
            return false;
        }
    })

    if(routeIndex >= 0) {
        lastRoutes.splice(routeIndex, 1);
    }

    lastRoutes.unshift(route);
    if(lastRoutes.length > maxResults) {
        lastRoutes.length = maxResults;
    }
    setBrowserSessionData('last-routes', lastRoutes);
    commit('setLastRoutes', lastRoutes);
}
